<template>
  <div class="paddbox autobox">
    <div>
      <el-card>
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <!-- 通知列表 -->
          <el-tab-pane label="通知列表" name="通知列表">
            <el-table :data="messageList" border style="width: 100%" v-loading="messageLoading"
              element-loading-text="加载中..." empty-text="暂无通知"
              :header-cell-style="{ background: '#f5f7fa', color: '#606266' }">
              <el-table-column label="剧名" min-width="300" show-overflow-tooltip>
                <template #default="scope">{{ scope.row.playletNames ?? '-' }}</template>
              </el-table-column>
              <el-table-column label="素材数" width="90" align="center">
                <template #default="scope">{{ scope.row.materialCount ?? '-' }}</template>
              </el-table-column>
              <el-table-column label="通知文件" width="120" align="center">
                <template #default="scope">
                  <el-button v-if="scope.row.ossUrl" type="text" size="mini" @click="downloadFile(scope.row)">
                    下载
                  </el-button>
                  <span v-else>-</span>
                </template>
              </el-table-column>
              <el-table-column label="状态" width="100" align="center">
                <template #default="scope">
                  <el-tag v-if="isMessageRead(scope.row)" type="info" size="mini">已读</el-tag>
                  <el-tag v-else type="danger" size="mini">未读</el-tag>
                </template>
              </el-table-column>
              <el-table-column label="创建时间" width="170">
                <template #default="scope">{{ scope.row.createTime ?? '-' }}</template>
              </el-table-column>
              <el-table-column label="阅读时间" width="170">
                <template #default="scope">{{ scope.row.readTime ?? '-' }}</template>
              </el-table-column>
            </el-table>
            <div class="pagination">
              <pagination @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange" :total="total"
                :pagesize="pagesize" :currentPage="currentPage" />
            </div>
          </el-tab-pane>

          <!-- 监控推送任务 -->
          <el-tab-pane label="监控推送任务" name="监控推送任务">
            <div class="btn-toolbar">
              <el-button type="primary" size="mini" @click="handleCreateTask">
                <el-icon style="vertical-align: middle; margin-right: 4px">
                  <Plus />
                </el-icon>
                创建监控推送任务
              </el-button>
            </div>
            <el-table :data="taskList" border style="width: 100%" v-loading="taskLoading" element-loading-text="加载中..."
              empty-text="暂无监控任务" :header-cell-style="{ background: '#f5f7fa', color: '#606266' }">
              <el-table-column prop="taskName" label="任务名称" min-width="160" show-overflow-tooltip />
              <el-table-column prop="playletName" label="剧名" min-width="280" show-overflow-tooltip />
              <el-table-column label="最低点赞数" width="110" align="center">
                <template #default="scope">{{ thresholdText(scope.row.minLikeCount) }}</template>
              </el-table-column>
              <el-table-column label="最低曝光数" width="110" align="center">
                <template #default="scope">{{ thresholdText(scope.row.minExposure) }}</template>
              </el-table-column>
              <el-table-column label="免打扰时段" width="170" align="center">
                <template #default="scope">{{ quietTimeText(scope.row) }}</template>
              </el-table-column>
              <el-table-column label="状态" width="100" align="center">
                <template #default="scope">
                  <el-tag :type="taskStatusTagType(scope.row)" size="mini">{{ taskStatusText(scope.row) }}</el-tag>
                </template>
              </el-table-column>
              <el-table-column label="最近检查时间" width="170">
                <template #default="scope">{{ formatMsTime(scope.row.lastCheckTime) }}</template>
              </el-table-column>
              <el-table-column prop="creatorName" label="创建人" width="100">
                <template #default="scope">{{ scope.row.creatorName ?? '-' }}</template>
              </el-table-column>
              <el-table-column prop="createTime" label="创建时间" width="170">
                <template #default="scope">{{ scope.row.createTime ?? '-' }}</template>
              </el-table-column>
              <el-table-column prop="updateTime" label="更新时间" width="170">
                <template #default="scope">{{ scope.row.updateTime ?? '-' }}</template>
              </el-table-column>
              <el-table-column label="操作" width="130" align="center" fixed="right">
                <template #default="scope">
                  <el-button v-if="isTaskRunning(scope.row)" type="text" size="mini"
                    :loading="taskActionId === scope.row.id" @click="handleTaskAction('stop', scope.row)">
                    停止监控任务
                  </el-button>
                  <el-button v-else type="text" size="mini" :loading="taskActionId === scope.row.id"
                    @click="handleTaskAction('start', scope.row)">
                    恢复监控任务
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
            <div class="pagination">
              <pagination @handleSizeChange="handleSizeChange2" @handleCurrentChange="handleCurrentChange2"
                :total="total2" :pagesize="pagesize2" :currentPage="currentPage2" />
            </div>
          </el-tab-pane>
        </el-tabs>
      </el-card>
    </div>

    <!-- 创建监控推送任务弹窗 -->
    <el-dialog title="创建监控推送任务" v-model="createVisible" width="520px" :close-on-click-modal="false">
      <el-form label-width="110px" @submit.prevent>
        <el-form-item label="任务名称：" required>
          <el-input v-model="createForm.taskName" size="small" placeholder="请输入任务名称" clearable />
        </el-form-item>
        <el-form-item label="剧名：" required>
          <el-input v-model="createForm.names" type="textarea" :rows="6" size="small" placeholder="请输入剧名，一行一个" />
        </el-form-item>
        <el-form-item label="最低点赞数：" required>
          <el-input-number v-model="createForm.minLikeCount" :min="0" :precision="0" size="small"
            controls-position="right" style="width: 100%" placeholder="请输入最低点赞数" />
        </el-form-item>
        <el-form-item label="最低曝光数：" required>
          <el-input-number v-model="createForm.minExposure" :min="0" :precision="0" size="small"
            controls-position="right" style="width: 100%" placeholder="请输入最低曝光数" />
        </el-form-item>
        <el-form-item label="免打扰时间：">
          <el-time-picker is-range v-model="createForm.quietTime" value-format="HH:mm:ss" range-separator="至"
            start-placeholder="开始时间" end-placeholder="结束时间" style="width: 100%" />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button size="mini" @click="createVisible = false">取消</el-button>
        <el-button type="primary" size="mini" :loading="createLoading" @click="submitCreateTask">确定</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { notifyMessages, notifyTasks, notifyCreateTask, notifyStart, notifyStop } from '@/request/new/ADX'
import { ElMessage } from 'element-plus'
import { Plus } from '@element-plus/icons-vue'
import { reactive, toRefs, onMounted } from 'vue'
import pagination from '@/components/pagination.vue'

export default {
  name: 'notify',
  components: { pagination, Plus },
  setup() {
    const state = reactive({
      // 标签页，默认通知列表
      activeName: '通知列表',

      // 通知列表
      messageLoading: false,
      messageList: [],
      currentPage: 1,
      pagesize: 20,
      total: 0,

      // 监控推送任务
      taskLoading: false,
      taskList: [],
      currentPage2: 1,
      pagesize2: 20,
      total2: 0,
      // 正在执行停止/恢复操作的任务id
      taskActionId: null,

      // 创建监控推送任务弹窗
      createVisible: false,
      createLoading: false,
      createForm: {
        taskName: '',
        // 剧名文本，一行一个，提交时按行拆分为数组
        names: '',
        minLikeCount: 0,
        minExposure: 0,
        // 免打扰时间范围，格式 HH:mm:ss，提交时拼接日期
        quietTime: null,
      },
    })

    // 通知列表：请求参数 currentPage 页码、size 每页大小
    const notifyMessagesFun = () => {
      const params = {
        currentPage: state.currentPage,
        size: state.pagesize,
      }
      state.messageLoading = true
      notifyMessages(params)
        .then((res) => {
          state.messageList = res?.data?.data || []
          state.currentPage = res?.data?.currenPage || state.currentPage
          state.total = res?.data?.totalSize || 0
        })
        .catch(() => { })
        .finally(() => {
          state.messageLoading = false
        })
    }

    // 监控推送任务列表：请求参数 currentPage 页码、size 每页大小
    const notifyTasksFun = () => {
      const params = {
        currentPage: state.currentPage2,
        size: state.pagesize2,
      }
      state.taskLoading = true
      notifyTasks(params)
        .then((res) => {
          state.taskList = res?.data?.data || []
          state.currentPage2 = res?.data?.currenPage || state.currentPage2
          state.total2 = res?.data?.totalSize || 0
        })
        .catch(() => { })
        .finally(() => {
          state.taskLoading = false
        })
    }

    // 重置创建任务表单
    const resetCreateForm = () => {
      state.createForm.taskName = ''
      state.createForm.names = ''
      state.createForm.minLikeCount = 0
      state.createForm.minExposure = 0
      state.createForm.quietTime = null
    }

    // 打开创建监控推送任务弹窗
    const handleCreateTask = () => {
      resetCreateForm()
      state.createVisible = true
    }

    // 创建监控推送任务
    const submitCreateTask = () => {
      const taskName = String(state.createForm.taskName ?? '').trim()
      // 剧名一行一个，按行拆分并去除空白行
      const names = String(state.createForm.names ?? '')
        .split(/\r?\n/)
        .map((item) => item.trim())
        .filter((item) => item !== '')
      if (!taskName) {
        ElMessage.warning('请输入任务名称')
        return
      }
      if (names.length === 0) {
        ElMessage.warning('请添加至少一个剧名')
        return
      }
      if (state.createForm.minLikeCount === null || state.createForm.minLikeCount === undefined) {
        ElMessage.warning('请输入最低点赞数')
        return
      }
      if (state.createForm.minExposure === null || state.createForm.minExposure === undefined) {
        ElMessage.warning('请输入最低曝光数')
        return
      }

      // 免打扰时间：开始与结束需同时填写
      const quietTime = Array.isArray(state.createForm.quietTime) ? state.createForm.quietTime : []
      const quietStart = quietTime[0]
      const quietEnd = quietTime[1]
      let quietStartTime
      let quietEndTime
      if (quietStart || quietEnd) {
        if (!quietStart || !quietEnd) {
          ElMessage.warning('免打扰开始和结束时间需同时填写')
          return
        }
        const pad = (n) => String(n).padStart(2, '0')
        const d = new Date()
        const today = `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`
        quietStartTime = `${today} ${quietStart}`
        quietEndTime = `${today} ${quietEnd}`
      }

      state.createLoading = true
      const params = {
        taskName,
        names,
        minLikeCount: state.createForm.minLikeCount,
        minExposure: state.createForm.minExposure,
      }
      if (quietStartTime && quietEndTime) {
        params.quietStartTime = quietStartTime
        params.quietEndTime = quietEndTime
      }
      notifyCreateTask(params)
        .then(() => {
          ElMessage.success('创建成功')
          state.createVisible = false
          resetCreateForm()
          notifyTasksFun()
        })
        .catch(() => { })
        .finally(() => {
          state.createLoading = false
        })
    }

    // 标签页切换
    const handleClick = () => {
      if (state.activeName === '通知列表') {
        notifyMessagesFun()
      } else if (state.activeName === '监控推送任务') {
        notifyTasksFun()
      }
    }

    // 通知列表分页
    const handleCurrentChange = (e) => {
      state.currentPage = e
      notifyMessagesFun()
    }
    const handleSizeChange = (e) => {
      state.pagesize = e
      state.currentPage = 1
      notifyMessagesFun()
    }

    // 监控任务分页
    const handleCurrentChange2 = (e) => {
      state.currentPage2 = e
      notifyTasksFun()
    }
    const handleSizeChange2 = (e) => {
      state.pagesize2 = e
      state.currentPage2 = 1
      notifyTasksFun()
    }

    // 通知是否已读：有阅读时间或 status 为 1 视为已读
    const isMessageRead = (row) => {
      if (row?.readTime) return true
      return Number(row?.status) === 1
    }

    // 下载通知文件（ossUrl 为 Excel 直链）
    // 用隐藏 iframe 触发下载：不打开新标签页、不切换焦点，
    // 避免 window.open 抢焦点导致页面触发 visibilitychange 而额外发起一次 unreadCount 轮询
    const downloadFile = (row) => {
      if (!row?.ossUrl) return
      const iframe = document.createElement('iframe')
      iframe.style.display = 'none'
      iframe.src = row.ossUrl
      document.body.appendChild(iframe)
      // 下载发起后延迟移除 iframe
      setTimeout(() => {
        if (iframe.parentNode) iframe.parentNode.removeChild(iframe)
      }, 60000)
    }

    // 任务状态映射
    const TASK_STATUS_MAP = {
      0: { text: '已停止', type: 'info' },
      1: { text: '运行中', type: 'success' },
    }

    // 是否运行中（status 1 运行中 / 0 已停止）
    const isTaskRunning = (row) => Number(row?.status) === 1

    // 停止/恢复监控任务：type 为 stop / start
    const handleTaskAction = (type, row) => {
      if (!row?.id) return
      const requestFun = type === 'stop' ? notifyStop : notifyStart
      state.taskActionId = row.id
      requestFun({ taskId: row.id })
        .then(() => {
          ElMessage.success(type === 'stop' ? '已停止监控任务' : '已恢复监控任务')
          notifyTasksFun()
        })
        .catch(() => { })
        .finally(() => {
          state.taskActionId = null
        })
    }

    const taskStatusText = (row) => {
      const status = TASK_STATUS_MAP[row?.status]
      return status ? status.text : (row?.status ?? '-')
    }

    const taskStatusTagType = (row) => {
      const status = TASK_STATUS_MAP[row?.status]
      return status ? status.type : 'info'
    }

    // 毫秒时间戳格式化
    const formatMsTime = (val) => {
      if (val === undefined || val === null || val === '') return '-'
      const num = Number(val)
      if (isNaN(num)) return String(val)
      const d = new Date(num)
      const pad = (n) => String(n).padStart(2, '0')
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`
    }

    // 阈值展示：null 表示不过滤（接口文档约定）
    const thresholdText = (val) => {
      if (val === undefined || val === null || val === '') return '不过滤'
      return val
    }

    // 免打扰时段展示：只取时分秒，合并为一列
    const quietTimeText = (row) => {
      const start = row?.quietStartTime
      const end = row?.quietEndTime
      if (!start && !end) return '-'
      const toTime = (v) => {
        if (!v) return ''
        const s = String(v)
        // 格式 "yyyy-MM-dd HH:mm:ss"，取时间部分
        const idx = s.indexOf(' ')
        return idx >= 0 ? s.slice(idx + 1) : s
      }
      const sTime = toTime(start)
      const eTime = toTime(end)
      if (sTime && eTime) return `${sTime} 至 ${eTime}`
      return sTime || eTime || '-'
    }

    onMounted(() => {
      notifyMessagesFun()
    })

    return {
      ...toRefs(state),
      handleClick,
      handleCurrentChange,
      handleSizeChange,
      handleCurrentChange2,
      handleSizeChange2,
      handleCreateTask,
      submitCreateTask,
      isMessageRead,
      downloadFile,
      taskStatusText,
      taskStatusTagType,
      isTaskRunning,
      handleTaskAction,
      formatMsTime,
      thresholdText,
      quietTimeText,
    }
  },
}
</script>

<style lang="scss" scoped>
.btn-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}

.pagination {
  display: flex;
  justify-content: flex-end;
  margin-top: 12px;
}
</style>
